import { formatAnyDate } from '@helpers/dateUtils';
import {
  CHECK_DUPLICATED_PHONE_SUCCESS,
  CHECK_STEP_CANDIDATE_SUCCESS,
  CREATE_POST_PRESIGNED_SUCCESS,
  FLAIR_SET_AD_TEAM_DATA,
  FLAIR_SET_AM_TEAM_DATA,
  FLAIR_SET_BANK_OFFICE_DATA,
  FLAIR_SET_PRE_CANDIDATE_DETAIL_DATA,
  FLAIR_SET_TEAM_OFFICE_DATA,
  GENERATE_OTP_SUCCESS,
  GET_ASCORE_SUCCESS,
  GET_CHECK_APPLICATION_STATUS_SUCCESS,
  GET_ERE_DETAIL_SUCCESS,
  GET_TRACKING_SUCCESS,
  NOUS_GET_ASCORE_SUCCESS,
  NOUS_SET_PRE_CANDIDATE_DETAIL_DATA,
  POST_FILE_SUCCESS,
  REGISTER_BY_RECRUITER_SUCCESS,
  RELOAD_OTP_SUCCESS,
  SET_AD_CONFIG_FILTER,
  SET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  SET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  SET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
  SET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
  SET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
  SET_ALL_AD_DATA,
  SET_ALL_AM_DATA,
  SET_AOS_CONFIG_FILTER,
  SET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  SET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  SET_CONFIG_FILTER,
  SET_DISTRICTS_DATA,
  SET_EAPP_PROCESS_HISTORY_DATA,
  SET_ERECRUITMENT_PRE_CANDIDATE_CHANNEL_CODE,
  SET_EAPP_PROCESS_HISTORY_DATA_V2,
  SET_ERECRUITMENT_PRE_CANDIDATE_ID,
  SET_FILES_DATA,
  SET_KAPTCHA_DATA,
  SET_LIST_OF_VALUE_DATA,
  SET_LIST_OFFICE_DATA,
  SET_LIST_TRAINING_CLASS_DATA,
  SET_PRE_CANDIDATE_DETAIL_DATA,
  SET_PROVINCES_DATA,
  SET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  SET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  SET_STATUS_DATA,
  SET_TITLE_FOR_NOUS_DATA,
  SET_WARDS_DATA,
  UPDATE_BY_PRE_CANDIDATE_SUCCESS,
  VERIFY_OTP_SUCCESS,
} from './constants';
import { defaultSearchDateAgo } from '@pages/ERecruitment/Search/AgencySearch/config.js';

const date = new Date();
const agoDate = formatAnyDate(
  date.setDate(new Date().getDate() - defaultSearchDateAgo),
);

export const initialState = {
  eRecruitmentPendingData: [],
  eRecruitmentProcessedData: [],
  ADERecruitmentPendingData: [],
  ADERecruitmentProcessedData: [],
  ADERecruitmentCourseData: [],
  ADERecruitmentInfoCandidateCourseData: [],
  ADERecruitmentClassCandidateCourseData: [],
  AOSERecruitmentPendingData: [],
  AOSERecruitmentProcessedData: [],
  eappProcessHistoryData: [],
  filterConfig: {
    appNo: null,
    email: null,
    fromDate: agoDate,
    fullName: null,
    idNo: null,
    pageNumber: 0,
    pageSize: 100,
    phoneNumber: null,
    queryForTab: '',
    status: null,
    toDate: formatAnyDate(new Date()),
  },
  AOSFilterConfig: {
    adCode: null,
    appNo: null,
    channelCode: null,
    dateApprovedByAD: null,
    dateStartClass: null,
    email: null,
    fromDate: agoDate,
    fullName: null,
    idNo: null,
    onboardClassId: null,
    pageNumber: 0,
    pageSize: 100,
    phoneNumber: null,
    queryForTab: '',
    status: null,
    toDate: formatAnyDate(new Date()),
    territoryCode: null,
  },
  ADFilterConfig: {
    amCode: null,
    appNo: null,
    email: null,
    fromDate: agoDate,
    fullName: null,
    idNo: null,
    onboardClassId: null,
    pageNumber: 0,
    pageSize: 100,
    phoneNumber: null,
    queryForTab: '',
    status: null,
    toDate: formatAnyDate(new Date()),
    courseSearch: null,
  },
  statusData: [],
  allAdData: [],
  allAmData: [],
  listTrainingClassData: [],
  listOfValueData: [],
  provincesData: [],
  districtsData: [],
  wardsData: [],
  listOfficeData: [],
  preCandidateDetailData: {},
  register: null,
  checkDuplicatedPhone: null,
  createPostPresigned: false,
  postFile: null,
  tracking: null,
  files: [],
  updateByPreCandidate: null,
  checkStepCandidate: null,
  kaptcha: null,
  generateOtp: null,
  reloadOtp: null,
  verifyOtp: null,
  checkAppStatus: null,
  eReDetail: null,
  aScore: null,
  titleForNousData: [],
  nousPreCandidateDetailData: {},
  nousAscore: null,
  flairPreCandidateDetailData: {},
  eRecruitmentPreCandidateId: null,
  eRecruitmentPreCandidateChannelCode: null,
  eAppProcessHistoryDataV2: [],
};

const eRecruitmentReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SEARCH_PRE_CANDIDATE_PENDING_DATA:
      state = {
        ...state,
        eRecruitmentPendingData: payload,
      };
      break;
    case SET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA:
      state = {
        ...state,
        eRecruitmentProcessedData: payload,
      };
      break;
    case SET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA:
      state = {
        ...state,
        ADERecruitmentPendingData: payload,
      };
      break;
    case SET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA:
      state = {
        ...state,
        ADERecruitmentProcessedData: payload,
      };
      break;
    case SET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA:
      state = {
        ...state,
        ADERecruitmentInfoCandidateCourseData: payload,
      };
      break;
    case SET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA:
      state = {
        ...state,
        ADERecruitmentClassCandidateCourseData: payload,
      };
      break;
    case SET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA:
      state = {
        ...state,
        ADERecruitmentCourseData: payload,
      };
      break;
    case SET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA:
      state = {
        ...state,
        AOSERecruitmentPendingData: payload,
      };
      break;
    case SET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA:
      state = {
        ...state,
        AOSERecruitmentProcessedData: payload,
      };
      break;
    case SET_CONFIG_FILTER:
      state = {
        ...state,
        filterConfig: payload,
      };
      break;
    case SET_AOS_CONFIG_FILTER:
      state = {
        ...state,
        AOSFilterConfig: payload,
      };
      break;
    case SET_AD_CONFIG_FILTER:
      state = {
        ...state,
        ADFilterConfig: payload,
      };
      break;
    case SET_STATUS_DATA:
      state = {
        ...state,
        statusData: payload,
      };
      break;
    case SET_ALL_AD_DATA:
      state = {
        ...state,
        allAdData: payload,
      };
      break;
    case SET_ALL_AM_DATA:
      state = {
        ...state,
        allAmData: payload,
      };
      break;
    case SET_LIST_TRAINING_CLASS_DATA:
      state = {
        ...state,
        listTrainingClassData: payload,
      };
      break;
    case SET_LIST_OF_VALUE_DATA:
      state = {
        ...state,
        listOfValueData: payload,
      };
      break;
    case SET_PROVINCES_DATA:
      state = {
        ...state,
        provincesData: payload,
      };
      break;
    case SET_DISTRICTS_DATA:
      state = {
        ...state,
        districtsData: payload,
      };
      break;
    case SET_WARDS_DATA:
      state = {
        ...state,
        wardsData: payload,
      };
      break;
    case SET_LIST_OFFICE_DATA:
      state = {
        ...state,
        listOfficeData: payload,
      };
      break;
    case REGISTER_BY_RECRUITER_SUCCESS:
      state = {
        ...state,
        register: payload,
      };
      break;
    case CHECK_DUPLICATED_PHONE_SUCCESS:
      state = {
        ...state,
        checkDuplicatedPhone: payload,
      };
      break;
    case CREATE_POST_PRESIGNED_SUCCESS:
      state = {
        ...state,
        createPostPresigned: true,
      };
      break;
    case POST_FILE_SUCCESS:
      state = {
        ...state,
        postFile: payload,
      };
      break;
    case GET_TRACKING_SUCCESS:
      state = {
        ...state,
        tracking: payload,
      };
      break;
    case SET_FILES_DATA:
      state = {
        ...state,
        files: payload,
      };
      break;
    case UPDATE_BY_PRE_CANDIDATE_SUCCESS:
      state = {
        ...state,
        updateByPreCandidate: payload,
      };
      break;
    case CHECK_STEP_CANDIDATE_SUCCESS:
      state = {
        ...state,
        checkDuplicatedPhone: payload,
      };
      break;
    case SET_KAPTCHA_DATA:
      state = {
        ...state,
        kaptcha: payload,
      };
      break;
    case GENERATE_OTP_SUCCESS:
      state = {
        ...state,
        generateOtp: payload,
      };
      break;
    case RELOAD_OTP_SUCCESS:
      state = {
        ...state,
        reloadOtp: payload,
      };
      break;
    case VERIFY_OTP_SUCCESS:
      state = {
        ...state,
        verifyOtp: payload,
      };
      break;
    case GET_CHECK_APPLICATION_STATUS_SUCCESS:
      state = {
        ...state,
        checkAppStatus: payload,
      };
      break;
    case GET_ERE_DETAIL_SUCCESS:
      state = {
        ...state,
        eReDetail: payload,
      };
      break;
    case SET_PRE_CANDIDATE_DETAIL_DATA:
      state = {
        ...state,
        preCandidateDetailData: payload,
      };
      break;
    case SET_EAPP_PROCESS_HISTORY_DATA:
      state = {
        ...state,
        eappProcessHistoryData: payload,
      };
      break;
    case GET_ASCORE_SUCCESS:
      state = {
        ...state,
        aScore: payload,
      };
      break;
    case SET_TITLE_FOR_NOUS_DATA:
      state = {
        ...state,
        titleForNousData: payload,
      };
      break;
    case NOUS_SET_PRE_CANDIDATE_DETAIL_DATA:
      state = {
        ...state,
        nousPreCandidateDetailData: payload,
      };
      break;
    case NOUS_GET_ASCORE_SUCCESS:
      state = {
        ...state,
        nousAscore: payload,
      };
      break;
    case FLAIR_SET_PRE_CANDIDATE_DETAIL_DATA:
      state = {
        ...state,
        flairPreCandidateDetailData: payload,
      };
      break;
    case FLAIR_SET_BANK_OFFICE_DATA:
      state = {
        ...state,
        flairBankOfficesData: payload,
      };
      break;
    case FLAIR_SET_TEAM_OFFICE_DATA:
      state = {
        ...state,
        flairTeamOfficesData: payload,
      };
      break;
    case FLAIR_SET_AM_TEAM_DATA:
      state = {
        ...state,
        flairAmTeamsData: payload,
      };
      break;
    case FLAIR_SET_AD_TEAM_DATA:
      state = {
        ...state,
        flairAdTeamsData: payload,
      };
      break;
    case SET_ERECRUITMENT_PRE_CANDIDATE_ID:
      state = {
        ...state,
        eRecruitmentPreCandidateId: payload,
      };
      break;
    case SET_ERECRUITMENT_PRE_CANDIDATE_CHANNEL_CODE:
      state = {
        ...state,
        eRecruitmentPreCandidateChannelCode: payload,
      };
      break;
    case SET_EAPP_PROCESS_HISTORY_DATA_V2:
      state = {
        ...state,
        eAppProcessHistoryDataV2: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default eRecruitmentReducers;
